angular.module('picmonicng').directive('copyButton', [
  'toaster',
  function (toaster) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function (event) {
          scope.$apply(function () {
            send_ga('event', 'Referral', 'Copy Share Link');
            toaster.success(
              'Copied',
              attrs.successMessage ? attrs.successMessage : 'Referral URL has been copied to the clipboard.'
            );
          });
        });
      },
    };
  },
]);
